import React, { useState, useCallback, useEffect } from "react";
import EditExbondheader from './editexbondheader';
import EditExbondform from './editexbondform';
import { API_CONFIG, getHeaders, refreshAccessToken } from "../../config/api";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoader } from "../../context/loadercontext";
import CancelButton from "../common/ui/cancelbutton";
import Button from "../common/ui/button";
import { useAuth } from "../../context/AuthContext";

export default function Editexbond() {
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const location = useLocation();
    const { parentId, childId } = location.state || {};



    const [resultants, setResultants] = useState([]);
    const [sections, setSections] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [binumber, setBINumber] = useState([]);
    const [materialsList, setMaterials] = useState([]);
    const [availableWeights, setAvailableWeights] = useState({});
    const [records, setRecords] = useState([]);
    const [allRecords, setAllRecords] = useState([]);

    const [masterrecords, setmasterRecords] = useState({});
    const { logout } = useAuth();
    const [loadingResultants, setLoadingResultants] = useState(false);
    const [loadingSections, setLoadingSections] = useState(false);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [loadingBINumber, setLoadingBINumber] = useState(false);
    const [loadingMaterials, setLoadingMaterials] = useState(false);

    const exbondExportOptions = [
        { label: "Export", value: "export" },
        { label: "Exbond", value: "exbond" },
    ];

    const [formData, setFormData] = useState({
        biNumber: "",
        beNumber: "",
        beDate: "",
        section: "",
        exbondExport: "",
        resultant: "",
        material: "",
        dutyExbond: "",
        dollar: "",
        rate: "",
        apifetchweight: "",
        invoiceValue: "",
        customer: "",
        inbondBeDate: "",
    });


    const updateFormData = useCallback((field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    }, []);

    /* ===========================================================
       FETCH FUNCTIONS
       =========================================================== */

    // ============================================
    // FIX 1: In Editexbond.jsx - Update fetchResultant
    // ============================================
    const fetchResultant = useCallback(async () => {
        try {
            setLoadingResultants(true);
            let response = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.MATERIAL.GET_NAME}`,
                { method: "GET", headers: getHeaders(true) }
            );

            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    response = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.MATERIAL.GET_NAME}`,
                        { method: "GET", headers: getHeaders(true) }
                    );
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout();
                    return;
                }
            }

            const result = await response.json();
            if (result.status === 200) {
                setResultants(
                    result.data.map(m => ({
                        label: m.material_short_code?.toUpperCase(),     // ✅ Display short code in dropdown
                        value: m.material_id,                            // ✅ Material ID as value
                        fullName: m.material_name,                       // ✅ Full name for matching
                        material_short_code: m.material_short_code       // ✅ Short code for display
                    }))
                );
            }
        } finally {
            setLoadingResultants(false);
        }
    }, [logout]);

    const fetchSections = useCallback(async () => {
        try {
            setLoadingSections(true);

            let res = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SECTIONS.GET_ALL}`,
                { method: "GET", headers: getHeaders(true) }
            );

            // -------------------------
            // 🔥 If ACCESS TOKEN expired
            // -------------------------
            if (res.status === 401) {
                console.warn("Access token expired. Attempting refresh...");

                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry API call with new token
                    res = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SECTIONS.GET_ALL}`,
                        { method: "GET", headers: getHeaders(true) }
                    );
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout(); // redirect user
                    return;
                }
            }
            const data = await res.json();
            if (data.status === 200) {
                setSections(data.data.map(s => ({
                    label: s.section_name,
                    value: s.id,
                })));
            }
        } finally {
            setLoadingSections(false);
        }
    }, [logout]);

    const fetchCustomers = useCallback(async () => {
        try {
            setLoadingCustomers(true);

            let res = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CUSTOMERS.GET_ALL}`,
                { method: "GET", headers: getHeaders(true) }
            );

            // -------------------------
            // 🔥 If ACCESS TOKEN expired
            // -------------------------
            if (res.status === 401) {
                console.warn("Access token expired. Attempting refresh...");

                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry API call with new token
                    res = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CUSTOMERS.GET_ALL}`,
                        { method: "GET", headers: getHeaders(true) }
                    );
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout(); // redirect user
                    return;
                }
            }
            const data = await res.json();
            if (data.status === 200) {
                setCustomers(
                    data.data.map(c => ({
                        label: c.name
                            ? c.name
                                .toLowerCase()                  // normalize to lowercase first
                                .split(",")                     // split by comma
                                .map(part =>
                                    part
                                        .trim()
                                        .split(" ")
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                        .join(" ")
                                )
                                .join(", ")                     // join back with comma + space
                            : "",
                        value: c.id,
                    }))
                );
            }

        } finally {
            setLoadingCustomers(false);
        }
    }, [logout]);

    const fetchBINumber = useCallback(async () => {
        try {
            setLoadingBINumber(true);

            let res = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.INBOND.GET_BI_NUMBER}`,
                { method: "GET", headers: getHeaders(true) }
            );

            // -------------------------
            // 🔥 If ACCESS TOKEN expired
            // -------------------------
            if (res.status === 401) {
                console.warn("Access token expired. Attempting refresh...");

                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry API call with new token
                    res = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.INBOND.GET_BI_NUMBER}`,
                        { method: "GET", headers: getHeaders(true) }
                    );
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout(); // redirect user
                    return;
                }
            }
            const data = await res.json();
            if (data.status === 200) {
                setBINumber(data.data.map(item => ({
                    label: item.binumber.toUpperCase(),
                    value: item.id,
                })));
            }


        } finally {
            setLoadingBINumber(false);
        }
    }, [logout]);

    const fetchWeightAndDutyByMaterial = useCallback(async (childId) => {
        if (!childId) return;

        try {
            let response = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_INBOND_WEIGHT_DUTY(childId)}`,
                { headers: getHeaders(true) }
            );

            if (response.status === 401) {
                const newToken = await refreshAccessToken();
                if (newToken) {
                    response = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_INBOND_WEIGHT_DUTY(childId)}`,
                        { headers: getHeaders(true) }
                    );
                } else {
                    logout();
                    return;
                }
            }

            const data = await response.json();

            if (data.status === 200 && data.data) {
                const { inbond, exbond } = data.data;
                const available =
                    (Number(inbond?.inbond_weight || 0) - Number(exbond?.exbond_weight || 0));


                return available;
            }
        } catch (e) {
            toast.error("Failed to fetch weight/duty");
        }
    }, [logout]);


    /* ===========================================================
       EDIT MODE LOADER
       =========================================================== */

    const fetchEditDetails = useCallback(async () => {
        if (!parentId) return;

        setLoading(true);

        try {
            const safeChildId = childId !== null && childId !== undefined && childId !== "" ? String(childId) : "";

            let response = await fetch(
                `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_EDIT_DETAILS(parentId, safeChildId)}`,
                { headers: getHeaders(true) }
            );

            // Handle 401 - token refresh
            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    response = await fetch(
                        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_EDIT_DETAILS(parentId, safeChildId)}`,
                        { headers: getHeaders(true) }
                    );
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout();
                    return;
                }
            }

            const result = await response.json();

            if (result.status !== 200 || !result.data) {
                setFormData({});
                setRecords([]);
                setAllRecords([]);
                return;
            }

            const { master_data, child_data } = result.data;

            // ---------------------------
            // STORE MASTER DATA (parent) for reference only
            // ---------------------------
            const masterSummary = {
                total_duty: master_data.total_duty_exbond_amount_inr || 0,
                total_weight: master_data.total_weight || 0,
                total_invoice: master_data.total_invoice_amount_inr || 0
            };
            setmasterRecords(masterSummary);

            // ---------------------------
            // FORMAT ALL CHILD DATA
            // ---------------------------
            const formattedAll = (child_data || []).map(c => ({
                id: c.id,
                inbond_master_id: c.inbond_master_id,
                biNumber: c.inbond_bi_number,
                biNumberId: c.inbond_master_id,
                material: c.material_master_id,
                materialNameOnly: c.material_name,
                material_short_code: c.material_short_code,
                section: c.section_master_id,
                sectionName: c.section_name,
                customer: c.customer_master_id,
                customerName: c.customer_name,
                beNumber: c.be_number,
                beDate: c.be_date,
                exbondExport: c.type,
                resultant: c.resultant,
                resultantName: c.resultant,
                resultantShortCode: "",
                dutyExbond: c.duty_exbond_amount,
                dollar: c.dollar,
                rate: c.rate,
                apifetchweight: c.weight,
                invoiceValue: c.invoice_amount,
                dutypaid: c.is_duty_paid,
                inbond_child_id: c.inbond_child_id || c.material_master_id || 0
            }));

            setAllRecords(formattedAll);

            // ---------------------------
            // FILTER CHILD DATA IF CHILD SELECTED
            // ---------------------------
            const filteredChildData = childId
                ? formattedAll.filter(c => String(c.id) === String(childId))
                : formattedAll;

            setRecords(filteredChildData);

            // ---------------------------
            // ONLY POPULATE FORM IF A CHILD IS SELECTED
            // ---------------------------
            if (childId) {
                const firstChild = filteredChildData[0] || {};
                setFormData({
                    material: firstChild.material || "",
                    dutyExbond: firstChild.dutyExbond || "",
                    dollar: firstChild.dollar || "",
                    rate: firstChild.rate || "",
                    apifetchweight: firstChild.apifetchweight || "",
                    invoiceValue: firstChild.invoiceValue || "",
                    dutypaid: firstChild.dutypaid || false,
                    inbond_child_id: firstChild.inbond_child_id || 0,
                    children: filteredChildData
                });
            } else {
                // If only parent, keep form empty but store children list
                setFormData({
                    children: filteredChildData
                });
            }

        } catch (err) {
            console.error("Edit Exbond Load Error:", err);
            setFormData({});
            setRecords([]);
            setAllRecords([]);
        } finally {
            setLoading(false);
        }
    }, [parentId, childId, setLoading]);



    /* ===========================================================
       INIT LOAD
       =========================================================== */

    useEffect(() => {
        fetchResultant();
        fetchSections();
        fetchCustomers();
        fetchBINumber();
    }, []);

    useEffect(() => {
        fetchEditDetails();
    }, [fetchEditDetails]);

    const handleSubmit = async () => {
        if (records.length === 0) {
            toast.error("Please add at least one entry before submitting!");
            return;
        }

        try {
            setLoading(true);

            // Calculate totals
            const recordsToSubmit = allRecords.map(r => {
                // If this record was edited (exists in records), use updated version
                const editedRecord = records.find(er => er.id === r.id);
                return editedRecord || r;
            });

            // Calculate totals from ALL records
            const totalDutyExbond = recordsToSubmit.reduce(
                (sum, r) => sum + (Number(r.dutyExbond) || 0),
                0
            );
            const totalWeight = recordsToSubmit.reduce(
                (sum, r) => sum + (Number(r.apifetchweight) || 0),
                0
            );



            // Correct child mapping
            const exbondchild = records.map((record) => ({
                id: record.id,
                inbond_master_id: Number(record.inbond_master_id) || 0,
                inbond_child_id: Number(record.inbond_child_id) || 0,

                material_master_id: Number(record.material),
                section_master_id: Number(record.section),
                customer_master_id: Number(record.customer),

                be_number: String(record.beNumber),
                be_date: String(record.beDate),

                type: String(record.exbondExport),
                resultant: String(record.resultantName),

                duty_exbond_amount_inr: Number(record.dutyExbond),
                dollar_inr: Number(record.dollar),
                rate: Number(record.rate),
                weight: Number(record.apifetchweight),
                invoice_amount_inr: Number(record.invoiceValue),

                is_duty_paid: record.dutypaid ? true : false,
            }));

            // Final payload
            const payload = {
                total_duty_exbond_amount_inr: totalDutyExbond,
                total_weight: totalWeight,
                exbondchild: exbondchild,
            };


            // Helper function for API call
            const callApi = async () =>
                await fetch(
                    `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.UPDATE_COMPLETE(parentId)}`,
                    {
                        method: "PUT",
                        headers: getHeaders(true),
                        body: JSON.stringify(payload),
                    }
                );

            // Initial API call
            let response = await callApi();

            // -------------------------
            // 🔥 Handle 401 token expired
            // -------------------------
            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    // Retry the same API call
                    response = await callApi();
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout();
                    return;
                }
            }

            const result = await response.json();

            if (result.status === 200 || result.status === 201) {
                toast.success("Exbond updated successfully!");
                navigate("/ex-bond");
            } else {
                toast.error(result.message || "Failed to update exbond");
            }
        } catch (error) {
            console.error("Error submitting exbond:", error);
            toast.error("Failed to submit exbond. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="relative mx-auto w-full px-3 sm:px-4 md:px-6">
            <EditExbondheader />

            <EditExbondform
                formData={formData}
                updateFormData={updateFormData}
                records={records}
                setRecords={setRecords}
                allRecords={allRecords}
                setAllRecords={setAllRecords}
                resultantOptions={resultants}
                loadingResultants={loadingResultants}
                sectionOptions={sections}
                loadingSections={loadingSections}
                exbondExportOptions={exbondExportOptions}
                customerOptions={customers}
                loadingCustomers={loadingCustomers}
                biNumberOptions={binumber}
                loadingBINumber={loadingBINumber}
                materialOptions={materialsList}
                loadingMaterials={loadingMaterials}
                // onBINumberChange={fetchMaterialInbondDate}
                onFetchWeightDuty={fetchWeightAndDutyByMaterial}
                availableWeights={availableWeights}
                masterrecords={masterrecords}
                initialEditIndex={childId ? 0 : null}
                selectedchildId={childId}
            />

            <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4">
                <CancelButton
                    className="w-full sm:w-auto"
                    onClick={() => navigate("/ex-bond")}
                >
                    Cancel
                </CancelButton>

                <Button onClick={handleSubmit} className="w-full sm:w-auto">Update</Button>
            </div>
        </div>
    );
}
